import i18n from './i18n';

const pad = (n: number) => String(n).padStart(2, '0');

/** Spec §6.1 stamp format: YYYY-MM-DD HH:MM in the viewer's local time. */
export function stamp(iso: string): string {
  const d = new Date(iso);
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

/** A date-only value (yyyy-mm-dd) shown in the user's locale, e.g. 21/10/2026 for en-GB. */
export function formatDate(isoDate: string): string {
  const [y, m, d] = isoDate.split('-').map(Number);
  return new Intl.DateTimeFormat(i18n.language, {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    timeZone: 'UTC',
  }).format(new Date(Date.UTC(y!, m! - 1, d!)));
}

export function rowRef(prefix: string, seq: number) {
  return `${prefix}${String(seq).padStart(3, '0')}`;
}

// 700 shades: white initials stay at 4.5:1 or better on every one (WCAG AA)
const PALETTE = ['#1d4ed8', '#be185d', '#b45309', '#047857', '#6d28d9', '#b91c1c', '#0e7490', '#4d7c0f'];
export function colourFor(id: string) {
  let h = 0;
  for (const c of id) h = (h * 31 + c.charCodeAt(0)) | 0;
  return PALETTE[Math.abs(h) % PALETTE.length]!;
}

export function initials(name: string) {
  return name
    .split(/\s+/)
    .map((p) => p[0])
    .join('')
    .slice(0, 2)
    .toUpperCase();
}
